
import React from 'react';
import { Building } from 'lucide-react';

interface ErrorStateViewProps {
  error: string | null;
  showAsAdmin: boolean;
}

const ErrorStateView: React.FC<ErrorStateViewProps> = ({ error, showAsAdmin }) => {
  return (
    <div className="rounded-lg border border-destructive p-8 text-center">
      <Building className="mx-auto h-12 w-12 text-destructive" />
      <h3 className="mt-4 text-lg font-medium">Error loading organizations</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        {error}
      </p>
    </div>
  );
};

export default ErrorStateView;
